module.exports = __webpack_public_path__ + "static/media/distance.86c129aa.svg";